import type { IClientUser } from '../../interfaces/user';
import React from 'react';

import Navigation from '../../components/Navigation';
import ProjectFlow from '../../components/Project/Forms/ProjectFlow';

const NewProjectPage: React.FC<IClientUser> = (props: IClientUser) => {
  return (
    <main className="page-add-project">
      <Navigation {...props} />
      <section className="container">
        <ProjectFlow {...props} />
      </section>
    </main>
  );
};

export default NewProjectPage;
